import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: null, text: "" },
  { value: 1, text: "ヤマト YMTJP" },
  { value: 2, text: "佐川 SGWJP" },
  { value: 3, text: "チャーター OWNJP" },
]);
